import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { PermissionGuard } from './permission.guard';

// prettier-ignore

const routes: Routes = [
  { path: 'forbidden', component: ForbiddenComponent },

  /* DASHBOARD */
  { path: '',  loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: 'dashboard', redirectTo: '', pathMatch: 'full' },
  { path: 'user', loadChildren: () => import('./pages/user/user.module').then(m => m.UserModule) },
  { path: 'memos', loadChildren: () => import('./pages/memos/memos.module').then(m => m.MemosModule) },

  /* ADMIN */
  { path: 'admin/logs', loadChildren: () => import('./pages/admin/logs/logs.module').then(m => m.LogsModule) },
  { path: 'admin/users', loadChildren: () => import('./pages/admin/users/users.module').then(m => m.UsersModule) },
  { path: 'admin/usergroups', loadChildren: () => import('./pages/admin/usergroups/usergroups.module').then(m => m.UsergroupsModule) },
  { path: 'admin/corelogs', loadChildren: () => import('./pages/admin/corelogs/corelogs.module').then(m => m.CorelogsModule) },
  { path: 'admin/gitrepositories', loadChildren: () => import('./pages/admin/gitrepositories/gitrepositories.module').then(m => m.GitrepositoriesModule) },

  /* MONITORING */
  { path: 'emails', loadChildren: () => import('./pages/emails/emails.module').then(m => m.EmailsModule) },
  { path: 'executions', loadChildren: () => import('./pages/executions/executions.module').then(m => m.ExecutionsModule) },
  { path: 'executions-errors', loadChildren: () => import('./pages/executions-errors/executions-errors.module').then(m => m.ExecutionsErrorsModule) },
  { path: 'sms-messages', loadChildren: () => import('./pages/sms-messages/sms-messages.module').then(m => m.SmsMessagesModule) },
  { path: 'teamsmessages', loadChildren: () => import('./pages/teams-messages/teams-messages.module').then(m => m.TeamsMessagesModule) },

  /* MANAGEMENT */
  { path: 'clients', loadChildren: () => import('./pages/clients/clients.module').then(m => m.ClientsModule) },
  { path: 'secrets', loadChildren: () => import('./pages/secrets/secrets.module').then(m => m.SecretsModule) },
  { path: 'systems', loadChildren: () => import('./pages/systems/systems.module').then(m => m.SystemsModule) },
  { path: 'queues', loadChildren: () => import('./pages/queues/queues.module').then(m => m.QueuesModule) },
  { path: 'resource-locks', loadChildren: () => import('./pages/resource-locks/resource-locks.module').then(m => m.ResourceLocksModule) },
  { path: 'settings', loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule) },

  /* TOOLS */
  { path: 'saved-forms', loadChildren: () => import('./pages/saved-forms/saved-forms.module').then(m => m.SavedFormsModule) },
  { path: 'kohodocuments', loadChildren: () => import('./pages/kohodocuments/kohodocuments.module').then(m => m.KohodocumentsModule) },
  { path: 'sign', loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule) },
  { path: 'triggers', loadChildren: () => import('./pages/triggers/triggers.module').then(m => m.TriggersModule) },
  { path: 'kohosearch', loadChildren: () => import('./pages/kohosearch/kohosearch.module').then(m => m.KohosearchModule) },
  { path: 'kohoprices', loadChildren: () => import('./pages/kohoprices/kohoprices.module').then(m => m.KohoPricesModule) },
  { path: 'tasks', loadChildren: () => import('./pages/tasks/tasks.module').then(m => m.TasksModule) },
  { path: 'requests', loadChildren: () => import('./pages/requests/requests.module').then(m => m.RequestsModule) },
  { path: 'process-models', loadChildren: () => import('./pages/process-models/process-models.module').then(m => m.ProcessModelsModule) },
  { path: 'announcements', loadChildren: () => import('./pages/announcements/announcements.module').then(m => m.AnnouncementsModule) },
  { path: 'pulse', loadChildren: () => import('./pages/pulse/pulse.module').then(m => m.PulseModule) },
  { path: 'botmessages', loadChildren: () => import('./pages/botmessages/botmessages.module').then(m => m.BotMessagesModule) },

  /* RAN CLI token provider */
  { path: 'rancli-token-redirect', loadComponent: () => import('./pages/rancli/rancli.component').then(m => m.RancliComponent) },

  /* 404 */
  { path: '**', loadChildren: () => import('./pages/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule) }
];

// Make sure every route has canLoad permission guard – not sure if the most optimal way to do it
routes.forEach((route) => {
  if (!route.canLoad) {
    route.canLoad = [PermissionGuard];
  }
});

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
